import { render, staticRenderFns } from "./EditPermissionsModal.vue?vue&type=template&id=f97c52ca"
import script from "./EditPermissionsModal.vue?vue&type=script&lang=js"
export * from "./EditPermissionsModal.vue?vue&type=script&lang=js"
import style0 from "./EditPermissionsModal.vue?vue&type=style&index=0&id=f97c52ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports